import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const PropertyLookupSummaryRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  address: new LookupAddress({}),
  manuallyAdded: null,
  subscriber: false
});

export class PropertyLookupSummary extends PropertyLookupSummaryRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  address: LookupAddress;
  manuallyAdded: boolean;
  subscriber: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/property-lookup-summary.ts